import { generateRuntimeConfig } from './dynamicEnv';
generateRuntimeConfig();

import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TelemetryModule, TelemetryHttpClientModule, TelemetryContextService } from '@rccl/telemetry-angular';
import { ErrorHandlerService } from '~app/shared/services/error-handler/error-handler.service';
import { SharedModule } from '~app/shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TelemetryConfig } from './telemetry.config';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    TelemetryHttpClientModule,
    TelemetryModule.forRoot(TelemetryConfig.config),
  ],
  providers: [{ provide: ErrorHandler, useClass: ErrorHandlerService }, TelemetryContextService],
  bootstrap: [AppComponent],
})
export class AppModule {}
